import { Route } from 'react-router';
import { lazy } from 'react';
import RouteMap from 'es/app/views/system/RouteMap';
import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';

const People = lazy(() => import('es/app/views/system/people'));
const EditPeople = lazy(() => import('es/app/views/system/people/edit'));
const EditPeopleForm = lazy(() => import('es/app/views/system/people/edit/details'));
const EditPeopleAccessGroups = lazy(() => import('es/app/views/system/people/edit/access-groups'));
const EditPeoplePermissionOverrides = lazy(
    () => import('es/app/views/system/people/edit/permission-overrides/PermissionOverrides')
);

export function PeopleRoutes() {
    return (
        <Route path={RouteMap.people.search()} element={<People />} ErrorBoundary={RouteErrorBoundary}>
            <Route path={RouteMap.people.create()} element={<EditPeople />}>
                <Route index element={<EditPeopleForm />} />
            </Route>
            <Route path={RouteMap.people.edit().root} element={<EditPeople />}>
                <Route index element={<EditPeopleForm />} />
                <Route path={RouteMap.people.edit().access} element={<EditPeopleAccessGroups />} />
                <Route path={RouteMap.people.edit().overrides} element={<EditPeoplePermissionOverrides />} />
            </Route>
        </Route>
    );
}
